import { Plan } from '../models/plans';
import { Discount } from '../features/discount/discountSlice';
import { GetMonthlyCost, getDiscountPlanCost } from '../components/OrderSummary';

export interface CardPrice {
  price: string;
  // The code the price needs, when it is the plan's promo price.
  promoCode?: string;
}

// A code applied in the URL or at checkout that lowers the monthly price.
const lowersPrice = (discount?: Discount): boolean => (
  !!discount
  && discount.period !== 0
  && discount.starting_period === 0
  && (Number(discount.percentage) > 0 || discount.dollar_amount > 0)
);

/**
 * The price in green on the plan card.
 *
 * With the promoPricing flag off (the default) it is what the card always
 * showed: the plan price, less any code the customer has applied.
 *
 * With the flag on, once a code is applied it is the plan price less that
 * code. Until then a plan with a promo code shows the price with it, and the
 * code: the promo is only applied when the customer brings it.
 */
export const cardPrice = (plan: Plan, discount?: Discount, promoPricing = false): CardPrice => {
  if (!promoPricing) {
    return {
      price: discount?.period !== 0
        ? String(getDiscountPlanCost(GetMonthlyCost(plan), discount))
        : plan.cost,
    };
  }
  if (lowersPrice(discount)) {
    return { price: String(getDiscountPlanCost(Number(plan.cost), discount)) };
  }
  if (plan.promo_code && Number(plan.promo_cost) > 0) {
    return { price: String(plan.promo_cost), promoCode: plan.promo_code };
  }
  return {
    price: discount?.period !== 0
      ? String(getDiscountPlanCost(Number(plan.cost), discount))
      : plan.cost,
  };
};
